<form [formGroup]="specPVVFormGroup">
    <div formGroupName="specificatiePVV">
        <div formGroupName="opbouw">
            <div *ngFor="let propertyName of propertyNamesToCheck; let i = index">
                    <div class="flex-container-dialog">
                        <div class="flex-item-tekst-dialog pb-2" *ngIf=" i < 2 || i === 3 ">
                            <p>{{ propertyTextMap[propertyName] }}</p>
                        </div>
                        <div *ngIf=" i < 2 ">
                            <snelstart-ui-number-form-control
                                    [formControlName]="propertyName"
                                    [id]="propertyName"
                                    class="me-1 custom-input-150 "
                                    [decimals]="0"
                                    align="right"
                                    prefix="€"
                                    placeholder="0"
                                    [disabledControl]=true
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div *ngIf=" i === 3">
                            <snelstart-ui-number-form-control
                                    [formControlName]="propertyName"
                                    [id]="propertyName"
                                    class="custom-input-150"
                                    [decimals]="2"
                                    align="right"
                                    prefix="%"
                                    placeholder="0"
                                    [disabledControl]=true
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</form>

<div class="space20"></div>

<form [formGroup]="specPVVFormGroup">
    <div formGroupName="specificatiePVV">
        <div formGroupName="opbouw">
            <div *ngFor="let propertyName of propertyNamesToCheck; let i = index">
                <div class="flex-container-dialog">
                        <div class="flex-item-tekst-dialog pb-2" *ngIf=" i > 3">
                            <p>{{ propertyTextMap[propertyName] }} (afgerond)</p>
                        </div>
                        <div *ngIf=" i > 3">
                            <snelstart-ui-number-form-control
                                    [formControlName]="propertyName"
                                    [id]="propertyName"
                                    class="custom-input-150"
                                    [decimals]="0"
                                    align="right"
                                    prefix="€"
                                    placeholder="0"
                                    [disabledControl]=true
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</form>

